import React from "react";

// Create a context object
const ScrollContext = React.createContext();

// Create a custom provider component
function ScrollProvider(props) {
  // Use state to hold the isBottom value
  const [isBottom, setIsBottom] = React.useState(false);
  const [scrollPosition, setScrollPosition] = React.useState(0);

  // Return the provider component with the value prop
  return (
    <ScrollContext.Provider value={{ isBottom, setIsBottom, scrollPosition, setScrollPosition }}>
      {props.children}
    </ScrollContext.Provider>
  );
}
// Export the context object as a default export
export { ScrollContext };
// Export the custom provider component
export { ScrollProvider };